module.exports = __webpack_public_path__ + "img/FO.fd474191.svg";